import { useState, type FormEvent } from 'react';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;

    const honeypot = form.querySelector<HTMLInputElement>('input[name="website_alt"]');
    if (honeypot && honeypot.value.trim() !== '') {
      setStatus('success');
      setEmail('');
      return;
    }

    setStatus('loading');
    setErrorMsg('');

    try {
      const formData = new FormData(form);
      const res = await fetch('https://readdy.ai/api/form/d9pc6tqftmtnfcfh0kgg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });

      const responseText = await res.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (res.ok && parsed?.code === 'OK') {
        setStatus('success');
        setEmail('');
      } else {
        const msg = parsed?.meta?.message || parsed?.message || '订阅失败，请稍后重试';
        setStatus('error');
        setErrorMsg(msg);
      }
    } catch {
      setStatus('error');
      setErrorMsg('网络错误，请稍后重试');
    }
  };

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=warm%20gradient%20abstract%20background%20with%20soft%20amber%20and%20coral%20tones%20gentle%20flowing%20shapes%20minimalist%20style%20elegant%20digital%20art%20subtle%20texture%20clean%20design&width=1920&height=600&seq=newsletter-bg-manhwa&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
          loading="lazy"
        />
      </div>
      <div className="absolute inset-0 bg-primary-900/70"></div>

      <div className="relative z-10 max-w-xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-background-50 mb-3">
          订阅更新通知
        </h2>
        <p className="text-sm md:text-base text-background-100/70 mb-8">
          第一时间获取最新漫画更新、热门推荐和独家活动信息
        </p>

        {status === 'success' ? (
          <div className="bg-background-50/20 backdrop-blur-sm border border-background-50/30 rounded-xl p-6">
            <div className="w-12 h-12 rounded-full bg-accent-500 flex items-center justify-center mx-auto mb-3">
              <i className="ri-check-line text-xl text-background-50"></i>
            </div>
            <p className="text-background-50 font-semibold">订阅成功！</p>
            <p className="text-sm text-background-100/60 mt-1">感谢你的订阅，我们会将最新消息发送到你的邮箱。</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} data-readdy-form="" className="flex flex-col sm:flex-row gap-3">
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="输入你的邮箱地址"
              required
              className="flex-1 px-5 py-3 rounded-full bg-background-50 text-foreground-900 placeholder:text-foreground-400 text-sm border border-background-50/50 focus:outline-none focus:ring-2 focus:ring-accent-400"
            />
            <input
              type="text"
              name="website_alt"
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
              readOnly
              className="honeypot-field"
            />
            <button
              type="submit"
              disabled={status === 'loading'}
              className="px-8 py-3 bg-accent-500 text-background-50 font-semibold rounded-full hover:bg-accent-600 transition-all duration-300 whitespace-nowrap cursor-pointer text-sm disabled:opacity-60"
            >
              {status === 'loading' ? (
                <span className="flex items-center gap-2">
                  <i className="ri-loader-4-line animate-spin w-4 h-4 flex items-center justify-center"></i>
                  提交中...
                </span>
              ) : '订阅'}
            </button>
          </form>
        )}

        {status === 'error' && (
          <p className="text-red-300 text-sm mt-3">{errorMsg}</p>
        )}

        <p className="text-xs text-background-100/50 mt-4">
          我们尊重你的隐私，不会发送垃圾邮件。你可以随时取消订阅。
        </p>
      </div>
    </section>
  );
}